import React from 'react';
import { translate } from "../../base/Translation";

export default class Condition extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            values: []
        }
    }

    getAnswers() {
        let answers = [];

        if (typeof this.props.weave === "undefined") {
            return answers;
        }

        if (!this.props.weave.protocol && !this.props.weave.form) {
            return answers;
        }

        let sections = [];

        if (this.props.weave.protocol) {
            sections = this.props.weave.form.question_sections.concat(this.props.weave.protocol.question_sections);
        } else {
            sections = this.props.weave.form.question_sections;
        }

        sections.forEach((section, section_index) => {
            section.question_groups.forEach((group, group_index) => {
                group.questions.forEach((question, question_index) => {
                    let optgroup = {
                        name: (section_index + 1) + "." + (group_index + 1) + "." + (question_index + 1) + ". " + question.name,
                        values: []
                    }
                    question.question_possible_answers.forEach((answer, answer_index) => {
                        optgroup.values.push({
                            id: answer.id,
                            name: answer.name
                        })
                    });
                    answers.push(optgroup);
                });
            });
        });

        return answers;
    }

    getBranches() {

        let groups = [];

        if (typeof this.props.weave === "undefined") {
            return groups;
        }

        groups.push({
            name: translate("Prevádzky"),
            values: this.props.weave.branches
        });

        return groups;
    }

    getRepresentatives() {
        let groups = [];

        if (typeof this.props.weave === "undefined") {
            return groups;
        }

        groups.push({
            name: translate("Predajcovia"),
            values: this.props.weave.representatives
        });

        return groups;
    }

    getCities() {
        let groups = [];

        if (typeof this.props.weave === "undefined") {
            return groups;
        }

        groups.push({
            name: translate("Obce"),
            values: this.props.weave.cities
        });

        return groups;
    }

    componentDidMount() {
        this.handleParam(this.props.data.param);
    }

    onParamChange(evt) {
        this.props.onParamChange(evt.target.value);
        this.handleParam(evt.target.value);
    }


    handleParam(param) {
        if (param === "answer") {
            this.setState({ values: this.getAnswers() });
        }

        if (param === "branch") {
            this.setState({ values: this.getBranches() });
        }

        if (param === "representative") {
            this.setState({ values: this.getRepresentatives() });
        }

        if (param === "city") {
            this.setState({ values: this.getCities() });
        }
    }

    onOperatorChange(evt) {
        this.props.onOperatorChange(evt.target.value);
    }

    onValueChange(evt) {
        this.props.onValueChange(evt.target.value);
    }

    onDelete() {
        this.props.onDelete();
    }

    onAdd() {
        this.props.onAdd();
    }

    render() {
        return (
            <div key={this.props.index} className="form-group condition">
                <div className="row">
                    <div className="col-md-4">
                        <select value={this.props.data.param} className="form-control" onChange={this.onParamChange.bind(this)}>
                            <option value="answer">{translate("Odpoveď")}</option>
                            <option value="branch">{translate("Prevádzka")}</option>
                            <option value="city">{translate("Obec")}</option>
                            <option value="representative">{translate("Predajca")}</option>
                        </select>
                    </div>
                    <div className="col-md-2">
                        <select value={this.props.data.operator} className="form-control" onChange={this.onOperatorChange.bind(this)}>
                            <option value="is">{translate("sa rovná")}</option>
                            <option value="is not">{translate("sa nerovná")}</option>
                            <option value="bigger or equal">{translate("je väčšie alebo rovné než")}</option>
                            <option value="smaller then">{translate("je menšie než")}</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <select value={this.props.data.value} className="form-control" onChange={this.onValueChange.bind(this)}>
                            <option value={0}>{translate("Vyberte")}</option>
                            {this.state.values.map((group, index) => {
                                return (
                                    <optgroup key={index} label={group.name}>
                                        {group.values ? group.values.map((value, vindex) => {
                                            return <option key={vindex} value={value.id}>{value.name}</option>
                                        }) : ""}
                                    </optgroup>
                                )
                            })}
                        </select>
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-primary" onClick={this.props.onAdd.bind(this)}>{translate("a")}</button>
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-danger" onClick={this.onDelete.bind(this)}><i className="fa fa-trash" /></button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/statistic/parts/Condition.jsx